<div class="header-info bg-white p-4 rounded-lg shadow-sm border border-gray-200" 
     [attr.data-status]="sourceStatus"
     style="position: relative;">
  <!-- Edit Button in Bottom Right Corner -->
  <button
    *ngIf="canEditKontrolltermin()"
    mat-stroked-button
    color="primary"
    type="button"
    (click)="openEditDialog()"
    class="text-xs"
    style="position: absolute; bottom: 16px; right: 16px; z-index: 10;">
    <mat-icon class="w-4 h-4 mr-1">edit</mat-icon>
    <span>{{ 'HEADER_INFO.EDIT' | translate }}</span>
  </button>
  
  <div class="form">
    <div class="row">
      <div class="col-12 col-lg-6">
        <!-- Einsatznummer -->
        <div class="form-group">
          <label class="form-label" for="einsatznummer">{{ 'HEADER_INFO.EINSATZNUMMER' | translate }}</label>
          <div *ngIf="!isFieldEditable('einsatznummer')" class="detail-value">
            {{ kontrolltermin.einsatznummer || '-' }}
          </div>
          <input
            *ngIf="isFieldEditable('einsatznummer')"
            type="text"
            class="form-control"
            id="einsatznummer"
            [value]="kontrolltermin.einsatznummer"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            readonly />
        </div>

        <!-- Kunde -->
        <div class="form-group">
          <label class="form-label" for="kunde">{{ 'HEADER_INFO.CLIENT' | translate }}</label>
          <div *ngIf="!isFieldEditable('kunde')" class="detail-value">
            {{ kontrolltermin.kunde?.suchbegriff || kontrolltermin.kunde?.name || '-' }}
          </div>
          <input
            *ngIf="isFieldEditable('kunde')"
            type="text"
            class="form-control"
            id="kunde"
            [value]="kontrolltermin.kunde?.suchbegriff || kontrolltermin.kunde?.name"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            readonly />
        </div>

        <!-- Standort -->
        <div class="form-group">
          <label class="form-label" for="standort">{{ 'HEADER_INFO.LOCATION' | translate }}</label>
          <div *ngIf="!isFieldEditable('standort')" class="detail-value">
            {{ kontrolltermin.standort?.name || '-' }}
          </div>
          <input
            *ngIf="isFieldEditable('standort')"
            type="text"
            class="form-control"
            id="standort"
            [value]="kontrolltermin.standort?.name"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            readonly />
        </div>

        <!-- Monitoring & Prüfdatum (Two columns in one line) -->
        <div class="form-group">
          <div class="row" style="margin: 0;">
            <div class="col-6" style="padding-right: 0.5rem;">
              <label class="form-label" for="monitoring">{{ 'HEADER_INFO.MONITORING' | translate }}</label>
              <div *ngIf="!isFieldEditable('monitoring')" class="detail-value">
                {{ getMonitoringMonth() }}
              </div>
              <input
                *ngIf="isFieldEditable('monitoring')"
                type="text"
                class="form-control"
                id="monitoring"
                [value]="getMonitoringMonth()"
                class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                readonly />
            </div>
            <div class="col-6" style="padding-left: 0.5rem;" *ngIf="shouldShowPruefdatum()">
              <label class="form-label" for="pruefdatum">{{ 'HEADER_INFO.PRUEFDATUM' | translate }}</label>
              <div class="detail-value">
                {{ kontrolltermin.datum_durchfuerung | date:'dd.MM.yyyy' || '-' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <!-- Status -->
        <div class="form-group">
          <label class="form-label" for="status">{{ 'HEADER_INFO.STATUS' | translate }}</label>
          <div class="detail-value">
            {{ getStatusText() }}
          </div>
        </div>

        <!-- Techniker -->
        <div class="form-group">
          <label class="form-label" for="techniker">{{ 'HEADER_INFO.TECHNICIAN' | translate }}</label>
          <div class="detail-value">
            {{ getTechnikerName() }}
          </div>
        </div>

        <!-- Time Fields (if enabled) -->
        <div *ngIf="showTimeFields" class="form-group">
          <label class="form-label" for="ist_zeit">{{ 'HEADER_INFO.DURATION' | translate }}</label>
          <div class="detail-value">
            {{ formatDurchfuehrungszeit() }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>